import type {
  PeaksAnalyzingStatus,
  RSSMetadataItem,
  Source,
  WaveformTrackItem
} from '../../../../../../types';

const getTrackUrl = (track: WaveformTrackItem) => {
  if (typeof track.link === 'string') {
    return track.link;
  }

  if (track.link && typeof track.link === 'object' && 'url' in track.link) {
    return track.link.url;
  }

  return undefined;
};

const hasValidUrl = (track: WaveformTrackItem) => {
  return !!getTrackUrl(track);
};

const isAnalysisComplete = (track: WaveformTrackItem) => {
  const completedStatuses: PeaksAnalyzingStatus[] = [
    'success',
    'generated',
    'error'
  ];

  return (
    !!track.peaks?.value &&
    !!track.peaks?.status &&
    completedStatuses.includes(track.peaks.status)
  );
};

const isAnalysisPending = (track: WaveformTrackItem) => {
  return track.peaks?.status === 'pending';
};

export const getAnalysisProgress = (source: Source | RSSMetadataItem[]) => {
  if (typeof source === 'string' || !Array.isArray(source)) {
    return { completed: 0, total: 0, pending: 0 };
  }

  const tracksNeedingPeaks = source.filter(hasValidUrl);

  const completed = tracksNeedingPeaks.filter(isAnalysisComplete).length;
  const pending = tracksNeedingPeaks.filter(isAnalysisPending).length;

  return {
    completed,
    total: tracksNeedingPeaks.length,
    pending
  };
};
